import styled from 'styled-components';

export const Logo = styled.img`
  width: 28px;
  height: 20px;
`;
